import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <h1 className="logo" onClick={() => navigate('/dashboard')}>
            🎓 Academia
          </h1>
        </div>
        <div className="header-right">
          {isAdmin && (
            <>
              <button
                className="admin-link"
                onClick={() => navigate('/progress')}
              >
                📊 Progreso
              </button>
              <button
                className="admin-link"
                onClick={() => navigate('/admin')}
              >
                ⚙️ Admin
              </button>
            </>
          )}
          <div className="user-info">
            <span>👤 {user?.email?.split('@')[0]}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
